import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const deleteEvent = async (id: number) => {
	const response = await cmsClient.delete(`/homepage/admin/events/${id}/`);

	return response.data;
};

const useDeleteEvent = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Event deleted successfully" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["events"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(deleteEvent, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useDeleteEvent;
